'use strict';

const { alertMessage } = require('../common/common');

function setWishlistIconInList(trigger) {
    // The function is triggered on load, param is used to avoid this
    if (!trigger) return;

    const wishlistList = sessionStorage.getItem('wishlistList');
    if (!wishlistList) return;

    const list = wishlistList?.split(",");
    const tiles = document.querySelectorAll("div.product.cc-product");

    if (!list?.length || !tiles?.length) return;

    tiles.forEach(item => {
        let pid = item.getAttribute("data-pidmaster");
        if (!pid) {
            pid = item.getAttribute("data-pid");
        }
        if (list.includes(pid)) {
            const button = item.querySelector("button.cc-tile__wishlist.cc-icon-wishlist");
            if (button) {
                button.classList.add("js-added-wishlist");
                button.classList.add("cc-icon-wishlist--added");
                button.setAttribute("aria-pressed", "true");
            }
        }
    });
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var icon = $(this).find($('i'));
            var url = $(this).attr('href') || $(this).data('href');
            var pid = $(this).closest('.product').data('pid') || $(this).closest('.product-detail').data('pid');
            var pidVariant = $(this).closest('.product').data('pidvariant') || $(this).closest('.product-detail').data('pidvariant');
            var optionId = $('.js-pdp-main').find('.product-option').data('option-id');
            var optionVal = $('.js-pdp-main').find('.options-select.selected').data('value-id');
            var countWrap = $('.js-wishlist');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            var $el = $(this);

            if ($(this).hasClass('js-added-wishlist')) {
                url = $(this).data('remove');
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        if (data.success) {
                            $el.removeClass('js-added-wishlist');
                            $el.removeClass('cc-icon-wishlist--added');
                            $el.removeAttr('aria-pressed');
                        }

                        if (typeof data.wishlistLength !== "undefined") {
                            if (data.wishlistLength === 0) {
                                $(countWrap).addClass('d-none');
                                $(countWrap).removeClass('d-inline-flex');
                            } else {
                                $(countWrap).addClass('d-inline-flex');
                                $(countWrap).removeClass('d-none');
                            }
                            $(countWrap).text(data.wishlistLength);
                        }

                        if (data.redirectUrl) {
                            location.href = data.redirectUrl;
                        } else {
                            alertMessage(data.msg, 'cc-alert--success');
                        }
                        //IOC-281
                        if (data.analyticsData) {
                            dataLayer.push(data.analyticsData);
                        }

                        if ($el.closest('.js-product-slider.js-wishlist-slider').length > 0) {
                            const $slickSlider = $el.closest('.js-product-slider').find('.js-slider');
                            const slideIndex = $el.closest('.slick-slide').index();
                            $slickSlider.slick('slickRemove', slideIndex);
                        }

                        sessionStorage.setItem('wishlistList', data.wishlistList);
                    },
                    error: function (err) {
                        alertMessage(err.msg, 'cc-alert--danger');
                    }
                });
            } else {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        pid: pidVariant || pid,
                        optionId: optionId,
                        optionVal: optionVal
                    },
                    success: function (data) {
                        if (data.success) {
                            $el.addClass('js-added-wishlist');
                            $el.addClass('cc-icon-wishlist--added');
                            $el.attr('aria-pressed', 'true');
                        }

                        if (data.wishlistLength) {
                            if (data.wishlistLength === 0) {
                                $(countWrap).addClass('d-none');
                                $(countWrap).removeClass('d-inline-flex');
                            } else {
                                $(countWrap).addClass('d-inline-flex');
                                $(countWrap).removeClass('d-none');
                            }
                            $(countWrap).text(data.wishlistLength);
                        }
                        if (data.redirectUrl) {
                            location.href = data.redirectUrl;
                        } else {
                            alertMessage(data.msg, 'cc-alert--success');
                        }
                        //IOC-281
                        if (data.analyticsData) {
                            dataLayer.push(data.analyticsData);
                        }

                        sessionStorage.setItem('wishlistList', data.wishlistList);
                    },
                    error: function (err) {
                        alertMessage(err.msg, 'cc-alert--danger');
                    }
                });
            }
        });
    },
    setWishlistIconInList: setWishlistIconInList
};
